import { mergeAttributes } from '@tiptap/core'
import TiptapParagraph from '@tiptap/extension-paragraph'

export const Paragraph = TiptapParagraph.extend({
  addAttributes() {
    return {
      textAlign: { default: '' },
      class: { default: '' },
    }
  },
  renderHTML({ node, HTMLAttributes }) {
    return ['p', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0]
  },
  addKeyboardShortcuts() {
    return {
      Backspace: ({ editor }) => {
        const { state } = editor
        const { selection } = state
        const { $from, empty } = selection

        if (!empty) {
          return false
        }

        if ($from.parent.type.name !== 'paragraph') {
          return false
        }

        const isEmpty = $from.parent.content.size === 0
        const isAtStart = $from.parentOffset === 0

        // If the paragraph is empty and we're at the start, delete it
        if (isEmpty && isAtStart) {
          const pos = $from.before()
          return editor.chain().setNodeSelection(pos).deleteSelection().run()
        }

        return false
      },
    }
  },
})

export default Paragraph
